module.exports = __webpack_public_path__ + "media/images/div_lens/masonry-img-1-d07dd0317e7cdb237bc544b4b82b3d5f.png";